<template>
  <v-row no-gutters>
    <v-col
      md="8"
      offset-md="2">
      <v-container class="page page--form">
        <ValidationObserver
          ref="obs"
          v-slot="{ valid, handleSubmit }">
          <v-form
            @submit.prevent="handleSubmit(onSubmit)">
            <validation-input
              v-model="mgc_fields.mgc_api_host"
              rules="required"
              label="Url api *" />
            <validation-input
              v-model="mgc_fields.mgc_api_login"
              rules="required"
              label="Login *" />
            <validation-input
              v-model="mgc_fields.mgc_api_password"
              rules="required"
              label="Mot de passe *" />
            <validation-input
              v-model="mgc_fields.mgc_reference"
              rules="required"
              label="Référence *" />
            <validation-input
              v-model="mgc_fields.mgc_client"
              rules="required"
              label="Client *" />
            <address-input
              :source="address"
              @update="updateAddress" />

            <validation-input
              v-model="mgc_fields.mgc_contact_city"
              rules="required"
              label="Ville *" />
            <validation-input
              v-model="mgc_fields.mgc_contact_zip_code"
              rules="required"
              label="Code postal *" />
            <validation-input
              v-model="mgc_fields.mgc_contact_email"
              rules="required|email"
              label="Email *" />
            <validation-input
              v-model="mgc_fields.mgc_contact_tel"
              rules="required|min:10|max:13"
              label="Téléphone *" />
            <validation-input
              v-model="mgc_fields.mgc_contact_url"
              rules="required"
              label="Url *" />
            <validation-input
              v-model="mgc_fields.mgc_logo"
              rules="required"
              label="Url logo *" />
            <v-btn
              type="submit"
              color="secondary"
              outlined
              @click="isformValid()">
              Enregistrer
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
  import RESOURCES from '@batimentb/vadimm-js-api/resources'
  export default {
    name: 'Mgc',
    data () {
      return {
        isLoading: false,
        account: {},
        mgc_fields: {},
        address: null
      }
    },
    computed: {
      accountPk () {
        return this.$route.params.id
      }
    },
    beforeMount () {
      this.getAccount()
    },
    methods: {
      updateAddress (value) {
        this.$set(this.mgc_fields, 'mgc_contact_address', `${value.line1}, ${value.zip_code} ${value.city}`)
        this.$set(this.mgc_fields, 'mgc_contact_city', value.city)
        this.$set(this.mgc_fields, 'mgc_contact_zip_code', value.zip_code)
        this.address = value
      },
      async getAccount () {
        let { data } = await this.$api.getOne(RESOURCES.ACCOUNT, this.accountPk)
        if (!data.mgc_fields) {
          this.mgc_fields = {}
          // set default values :
          this.address = data.address
          this.mgc_fields.mgc_contact_address = `${data.address.line1}, ${data.address.zip_code} ${data.address.city}`
          this.mgc_fields.mgc_contact_city = data.address.city
          this.mgc_fields.mgc_contact_zip_code = data.address.zip_code
          this.mgc_fields.mgc_client = data.name
        } else {
          this.address = {
            line1: data.mgc_fields.mgc_contact_address.split(data.mgc_fields.mgc_contact_zip_code)[0].trim(),
            zip_code: data.mgc_fields.mgc_contact_zip_code,
            city: data.mgc_fields.mgc_contact_city
          }
          this.mgc_fields = data.mgc_fields
        }
      },
      async isformValid () {
        if (!this.$refs.obs.flags.valid) {
          this.$awn.warning('Formulaire invalide')
        }
      },
      async onSubmit () {
        this.mgc_fields.mgc_client = this.mgc_fields.mgc_client.toUpperCase()
        try {
          await this.$api.patch(RESOURCES.ACCOUNT, this.accountPk, { mgc_fields: this.mgc_fields })
          this.$awn.success('MGC enregistré')
          await this.$router.replace({ name: 'accountVue', params: { id: this.accountPk } })
        } catch (e) {
          this.$awn.warning('Erreur lors de l\'enregistrement')
        }
      }
    }
  }
</script>

<style scoped>

</style>
